import { useMutation } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

export interface AutomationJobResponse {
  jobId: string;
  message: string;
  statusUrl: string;
  downloadUrl: string;
}

export default function useExecuteAutomation() {
  return useMutation({
    mutationFn: async (id: string): Promise<AutomationJobResponse> => {
      if (!id) throw new Error("No automation ID provided");

      const response = await axios.post(
        `${AUTOMATION_SERVICE_ADDRESS}/automation/${id}/run`,
        undefined,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (response.status !== 202) {
        throw new Error(`Failed to start automation job: ${response.statusText}`);
      }

      return response.data as AutomationJobResponse;
    }
  });
}
